/**
 * request-type.js
 */

import React from 'react';
import { Tooltip, Chip } from '@mui/material';
import { UserContext } from 'contexts/user/user-context';
import { Types } from 'utils/constants';
import Icon from 'components/icon';


export default function RequestType(props) {
  const { 
    context, // training-group | training-member | manager-group | manage
    request
  } = props;
  const { user } = React.useContext(UserContext);
  let tooltip = '';
  let label = '';
  let icon = '';


  // GROUPS PAGE - handler training group list
  if (context === 'training-group') {
    if (request.type === Types.MemberRequest.TO_USER) {
      tooltip = `You've been invited to this training group.`;
      label = 'Request received';
      icon = 'group-request-receive';
    } else if (request.type === Types.MemberRequest.FROM_USER) {
      tooltip = `You sent a request to join this group using a group code. You haven't been accepted yet.`;
      label = 'Request sent';
      icon = 'group-request-send';
    }
  } 
  // GROUP PAGE - group member list
  else if (context === 'training-member') {
    if (request.type === Types.MemberRequest.TO_USER && !request.code) {
      tooltip = `You're inviting this user to the training group. Press the Save button to send the invite.`;
      label = 'Request queued';
      icon = 'group-request-send';
    } else if (request.type === Types.MemberRequest.TO_USER && request.code) {
      tooltip = `This user is invited to join the training group. They haven't accepted yet.`;
      label = 'Request sent';
      icon = 'group-request-send';
    } else if (request.type === Types.MemberRequest.FROM_USER) {
      tooltip = `This user requested access to the training group.`;
      label = 'Request received';
      icon = 'group-request-receive';
    }
  } 
  // GROUPS PAGE - manager group list
  else if (context === 'manager-group') {
    const roleName = request.role.name.toLowerCase();
    if (request.creator.id === user.id) {
      tooltip = `You invited this ${roleName} to have access to your account. They haven't accepted yet.`;
      label = 'Request sent';
      icon = 'group-request-send';
    } else if (request.creator) {
      tooltip = `This ${roleName} has asked to have access to your account.`;
      label = 'Request received';
      icon = 'group-request-receive';
    }
  } 
  // MANAGE PAGE - pending requests list
  else if (context === 'manage') {
    if (request.role.id === Types.Role.SUPERVISOR) {
      if (request.creator.id === user.id) {
        tooltip = `You invited this handler to be supervised by you. They haven't accepted yet.`;
        label = 'Request sent';
        icon = 'group-request-send';
      } else if (request.creator) {
        tooltip = `This handler is requesting that you supervise their account. Use the Accept button to confirm.`;
        label = 'Request Received';
        icon = 'group-request-receive';
      }
    } else if (request.role.id === Types.Role.TRAINER) {
      if (request.creator.id === user.id) {
        tooltip = `You invited this handler to be trained by you. They haven't accepted yet.`;
        label = 'Request sent';
        icon = 'group-request-send';
      } else if (request.creator) {
        tooltip = `This handler is requesting that you train them. Use the Accept button to confirm.`;
        label = 'Request Received';
        icon = 'group-request-receive';
      }
    } else if (request.role.id === Types.Role.MANAGER) {
      if (request.creator.id === user.id) {
        tooltip = `You invited this supervisor to be managed by you. They haven't accepted yet.`;
        label = 'Request sent';
        icon = 'group-request-send';
      } else if (request.creator) {
        tooltip = `This supervisor is requesting management access to your account. Use the Accept button to confirm.`;
        label = 'Request Received';
        icon = 'group-request-receive';
      }
    }
  }
  
  return (
    <Tooltip arrow placement='top' title={tooltip}>
      <Chip size='small' icon={<Icon type={icon} />} label={label} />
    </Tooltip>
  );
}